var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"row"},[_c('span',{staticClass:"col-9"},[_vm._v(_vm._s(_vm.shown ? _vm.password : Array(_vm.password.length+1).join('*'))+" ")]),_c('i',{class:['kg', _vm.shown ? 'kg-hide': 'kg-show', 'cursor-pointer col-1 pr-2'],on:{"click":function($event){_vm.shown = !_vm.shown}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }